module.exports = __webpack_public_path__ + "assets/4901d3fe08a7189c122301ba42989365.png";